import React, { useState, useEffect } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RefreshIcon from "@mui/icons-material/Refresh";

// Shows a generated password an admin has to hand to someone: monospace and
// selectable so it can always be read or copied by hand, with a copy button on
// top of that.
const PasswordBox = ({ value, onRegenerate }) => {
  const [note, set_note] = useState("");

  useEffect(() => {
    set_note("");
  }, [value]);

  const Copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      set_note("Đã copy");
    } catch (err) {
      // navigator.clipboard is undefined outside secure contexts (plain http),
      // so say so instead of looking like the copy worked.
      set_note("Không copy được — bôi đen đoạn trên để copy tay");
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          border: "1px solid #E0E0E0",
          borderRadius: "8px",
          backgroundColor: "#F5F7FA",
          pl: 1.5,
          pr: 0.5,
          py: 0.5,
        }}
      >
        <Typography
          sx={{
            flex: 1,
            fontFamily: "monospace",
            fontSize: 15,
            fontWeight: 600,
            letterSpacing: 1,
            color: "#333",
            userSelect: "all",
            wordBreak: "break-all",
          }}
        >
          {value}
        </Typography>
        {onRegenerate != null && (
          <Tooltip title="Sinh lại">
            <IconButton size="small" onClick={onRegenerate}>
              <RefreshIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Copy">
          <IconButton size="small" onClick={() => Copy()}>
            <ContentCopyIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
      </Box>
      {note !== "" && (
        <Typography sx={{ fontSize: 12, color: "#666", mt: 0.5 }}>
          {note}
        </Typography>
      )}
    </Box>
  );
};

export { PasswordBox };
